import React from 'react';
import {Container, Row, Col, Button, Alert} from 'react-bootstrap';
import {Card} from 'react-bootstrap';
import Level3Title from '../../../../app/common/components/title/Level3Title';
import {useNavigate, createSearchParams} from 'react-router-dom';
import {useSearchParams} from 'react-router-dom';
import {useIntl} from 'react-intl';

const ConfigurationEndMonitoring = (CISID: any): JSX.Element => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const goToReclamation = () => {
    searchParams.append('TemplateReclamation', 'Demande_habilitations_myTelephony');
    searchParams.append('ServiceId', CISID.CISID ? CISID.CISID : '');
    navigate({
      pathname: `/support`,
      search: createSearchParams(searchParams).toString(),
    });
  };

  return (
    <Container fluid className="mt-5">
      <Card className="DetailsTelephonie col-12 col-xxl-6">
        <Card.Header>
          <Card.Title>
            <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.TEL.CONF.TITLE'})} />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Row className="mb-4 ">
            <Col>
              <p>
                {intl.formatMessage(
                  {id: 'CONFIGURATION.TEL.CONF.DESCRIPTION'},
                  {appName: <strong>myTelephony</strong>}
                )}
              </p>
            </Col>
          </Row>

          <Row className="mb-4 ">
            <Col>
              <Alert variant="info">
                {intl.formatMessage({id: 'CONFIGURATION.TEL.CONF.ACCESS_ALERT'})}
              </Alert>
              <br />
              <div className="d-flex gap-3">
                <Button variant="secondary" onClick={() => goToReclamation()}>
                  {intl.formatMessage({id: 'CONFIGURATION.TEL.CONF.SUPPORT_REQUEST'})}
                </Button>
                <a href="https://mytelephony.ctx.celeste.fr/login" target="_blank" rel="noreferrer">
                  <Button variant="primary">
                    {intl.formatMessage({id: 'CONFIGURATION.TEL.CONF.ACCESS_SERVICE'})}
                  </Button>
                </a>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};
export default ConfigurationEndMonitoring;
